import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import facebookIcon from '@assets/icons/icon-facebook.svg';
import instagramIcon from '@assets/icons/icon-instagram.svg';



const SideElement = () => {
	const { t } = useTranslation('links');

	return (
		<div className='app-side-element'>

			<Link to={t('socialMedia.facebook')} className='disable-selection' target='_blank'>
				<img src={facebookIcon} alt='social-media-facebook' />
			</Link>

			<Link to={t('socialMedia.instagram')} className='disable-selection' target='_blank'>
				<img src={instagramIcon} alt='social-media-instagram' />
			</Link>

		</div>
	);
};

export default SideElement;